export const DIWA_ADMIN_ROLE = 'diwa_admin';
export const DEFAULT_TOPIC_SCORE = 50;
export const POLL_SYNCSTATUS_DELAY = 4000;
export const TIMEOUT_QUEUEMSG_PICKUP = 20000;
export const TOPIC_MAXLENGTH_TOPIC_NAME = 450;
export const TOPIC_MAXLENGTH_DEFINITION = 4000;
export const TOPIC_MAXLENGTH_COMMENTS = 4000;
export const TOPIC_MAXLENGTH_TERM = 400;
export const TOPIC_INVALID_CHARACTER_ERROR_MSG = 'Topic name must have a value of valid characters (minimum 3 characters, without leading or trailing spaces)';
export const TOPIC_UNIQUE_VALUE_ERROR_MSG = 'Topic name must be unique';
export const TOPIC_MAXLENGTH_WARNING_MSG = 'You have reached the maximum limit of characters allowed';
